import { GzExchangeAntimalwareWebComponent } from './component/GzExchangeAntimalwareWebComponent';

export { GzExchangeAntimalwareWebComponent };
